import {StickyScrollProps} from "app/WebController/Component/Scroll/StickyScroll"
import {OnUpdatedEventListenerArgs, OverlayScrollbars, PartialOptions} from "overlayscrollbars"
import {OverlayScrollbarsComponent, OverlayScrollbarsComponentRef} from "overlayscrollbars-react"
import React, {forwardRef, useEffect, useState} from "react"
import mergeDeep from "utils/objectMergeDeep"

interface OverlayScrollbarsProps extends StickyScrollProps {
}

// Notes
// 1) Works perfectly when re-sizing elements
// 2) Properly doesn't show a scrollbar if not needed, unlike PerfectScrollbar
// 3) Natively supports dark/light mode
const StickyOverlayScrollbars = forwardRef<OverlayScrollbarsComponentRef, OverlayScrollbarsProps>(
  ({
     children,
     className,
     options,
     setHasScrollbar,
     display,
     contain,
   }: OverlayScrollbarsProps, ref) => {

    const [localOption, setLocalOptions] = useState<PartialOptions>({
        scrollbars: {
          autoHide: 'move',
          autoHideDelay: 500,
        },
      }
    )

    function scrollUpdated(instance: OverlayScrollbars, _onUpdatedArgs: OnUpdatedEventListenerArgs) {
      const {x, y} = instance.state().hasOverflow
      setHasScrollbar && setHasScrollbar(x || y)
    }

    useEffect(() => {
      if (undefined === options) return
      setLocalOptions(mergeDeep(localOption, options))
    }, [options])

    return (
      <OverlayScrollbarsComponent
        style={{
          display: display,
          flexGrow: 1,
          contain: contain,
        }}
        className={className}
        ref={ref}
        options={localOption}
        events={{
          updated: scrollUpdated,
        }}
      >
        {children}
      </OverlayScrollbarsComponent>
    )
  })

export default StickyOverlayScrollbars
